/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProposalWithClientResource } from './';
import {
    ProposalWithClientResourceFromJSON,
    ProposalWithClientResourceFromJSONTyped,
    ProposalWithClientResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProposalsWithClientResource
 */
export interface ProposalsWithClientResource {
    /**
     * The list of proposal waiting for a quote
     * @type {Array<ProposalWithClientResource>}
     * @memberof ProposalsWithClientResource
     */
    proposals: Array<ProposalWithClientResource>;
}

/**
 * Check if a given object implements the ProposalsWithClientResource interface.
 */
export function instanceOfProposalsWithClientResource(value: object): value is ProposalsWithClientResource {
    if (!('proposals' in value) || value['proposals'] === undefined) return false;
    return true;
}

export function ProposalsWithClientResourceFromJSON(json: any): ProposalsWithClientResource {
    return ProposalsWithClientResourceFromJSONTyped(json, false);
}

export function ProposalsWithClientResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalsWithClientResource {
    if (json == null) {
        return json;
    }
    return {
        
        'proposals': ((json['proposals'] as Array<any>).map(ProposalWithClientResourceFromJSON)),
    };
}

export function ProposalsWithClientResourceToJSON(value?: ProposalsWithClientResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'proposals': ((value['proposals'] as Array<any>).map((v) => ProposalWithClientResourceToJSON(v))),
    };
}

